import React from 'react';
import Select from 'react-select'
import Footer from '../../components/footer';
import { useMoralis } from 'react-moralis';
import { useEffect, useState } from 'react'
import MarketPlaceList from '../../components/admin/MarketPlaceList';
import { Link } from '@reach/router';
import { useWeb3React } from '@web3-react/core';

const customStyles = {
  option: (base, state) => ({
    ...base,
    background: "#212428",
    color: "#fff",
    borderRadius: state.isFocused ? "0" : 0,
    "&:hover": {
      background: "#16181b",
    }
  }),
  menu: base => ({
    ...base,
    background: "#212428 !important",
    borderRadius: 0,
    marginTop: 0
  }),
  menuList: base => ({
    ...base,
    padding: 0
  }),
  control: (base, state) => ({
    ...base,
    padding: 2
  })
};


const options = [
  { value: '-1', label: 'All categories' },
  { value: '1', label: 'Uncategorized' },
  { value: '2', label: 'Abstract' },
  { value: '3', label: 'Digital Art' },
  { value: '4', label: 'Photography' },
  { value: '5', label: '3D Animation' },
  { value: '6', label: 'Exclusive Drops' },
]

const status = [
  { value: '-1', label: 'Select status' },
  { value: 'pending', label: 'Pending' },
  { value: 'active', label: 'Active' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'on-hold', label: 'On hold' }
]


const Gallery = ({ walletAddress }) => {

  const { Moralis, isInitialized } = useMoralis()
  const [onSaleItems, setOnSaleItems] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [nftCategory, setNftCategory] = useState('-1')
  const [searchTerm, setSearchTerm] = useState('')
  const [nftStatus, setNftStatus] = useState('-1')
  const { account } = useWeb3React()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {

    if (isInitialized) {
      try {
        setIsLoading(true)
        const CreatedMarketplaceItems = Moralis.Object.extend("MarketplaceItems")
        const query = new Moralis.Query(CreatedMarketplaceItems)
        query.equalTo('sold', false)
        const result = await query.find()
        setOnSaleItems(result)
        setIsLoading(false)
      } catch (error) {
        setIsLoading(false)
        console.error('MORALIS ERROR : error while fetching marketplace data', error)
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized])

  const nftSearchHandle = async (e) => {
    const userInput = e.target.value
    if (userInput) {
      setSearchTerm(userInput)
    } else {
      setSearchTerm('')
    }

  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (searchTerm !== '') {
        if (isInitialized) {
          try {
            setIsLoading(true)
            const CreatedMarketplaceItems = Moralis.Object.extend("MarketplaceItems")
            const query = new Moralis.Query(CreatedMarketplaceItems)
            query.fullText('nftName', searchTerm)
            query.fullText('nftDescription', searchTerm)
            query.equalTo('sold', false)
            const result = await query.find()
            setOnSaleItems(result)
            setIsLoading(false)
          } catch (error) {
            setIsLoading(false)
            console.error('MORALIS ERROR : error while searching marketplace data', error)
          }

        }
      } else {
        setIsLoading(true)
        const query = new Moralis.Query("MarketplaceItems")
        query.equalTo('sold', false)
        const result = await query.find()
        setOnSaleItems(result)
        setIsLoading(false)
      }
    }, 400)

    return () => clearTimeout(delayDebounceFn)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {

    if (isInitialized) {
      try {
        setIsLoading(true)
        const query = new Moralis.Query("MarketplaceItems")
        query.equalTo('sold', false)
        if (nftCategory !== "-1") {
          query.equalTo('categoryId', nftCategory)
        }
        const result = await query.find()
        setOnSaleItems(result)
        setIsLoading(false)
      } catch (error) {
        setIsLoading(false)
        console.error('MORALIS ERROR : error while fetching marketplace data', error)
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized, nftCategory])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {

    if (isInitialized) {
      try {
        setIsLoading(true)
        const query = new Moralis.Query("MarketplaceItems")
        query.equalTo('sold', false)
        if (nftStatus !== "-1") {
          query.equalTo('status', nftStatus)
        }
        const result = await query.find()
        setOnSaleItems(result)
        setIsLoading(false)
      } catch (error) {
        setIsLoading(false)
        console.error('MORALIS ERROR : error while fetching marketplace data', error)
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized, nftStatus])

  const handleCategorySelect = (selectedCategory) => {
    setNftCategory(selectedCategory.value)
  }

  const handleStatusSelect = (selectedStatus) => {
    if (selectedStatus) {
      setNftStatus(selectedStatus.value)
    }
  }

  return (
    <div>

      {
        walletAddress === account ?
          (
            <section className='container'>
              <div className='row'>
                <div className='col-lg-12'>
                  <div className="items_filter">
                    <form className="row form-dark" id="form_quick_search" name="form_quick_search">
                      <div className="col">
                        <input className="form-control" onChange={nftSearchHandle} id="name_1" name="name_1" placeholder="search item here..." type="text" /> <button id="btn-submit"><i className="fa fa-search bg-color-secondary"></i></button>
                        <div className="clearfix"></div>
                      </div>
                    </form>
                    <div className='dropdownSelect one'>
                      <Select
                        className='select1'
                        styles={customStyles}
                        menuContainerStyle={{ 'zIndex': 999 }}
                        defaultValue={options[0]}
                        onChange={handleCategorySelect}
                        options={options} />
                    </div>
                    <div className='dropdownSelect one'>
                      <Select
                        className='select1'
                        styles={customStyles}
                        menuContainerStyle={{ 'zIndex': 999 }}
                        defaultValue={status[0]}
                        onChange={handleStatusSelect}
                        options={status} />
                    </div>
                    {/* <div className='dropdownSelect two'><Select className='select1' styles={customStyles} defaultValue={options1[0]} options={options1} /></div>
                  <div className='dropdownSelect three'><Select className='select1' styles={customStyles} defaultValue={options2[0]} options={options2} /></div> */}
                  </div>
                </div>
              </div>

              {
                isLoading ?
                  (
                    <section className='container'>
                      <div className='row'>
                        <div className='col-sm-12 col-md-12 col-lg-12'>
                          <div className='loading-container'>
                            <div className="spinner-grow" role="status">
                              <span className="sr-only">Loading...</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  ) : (
                    <MarketPlaceList data={onSaleItems} />

                  )
              }

            </section>
          ) :
          (

            <section className='container'>
              <div className='row'>
                <div className='col-lg-12'>
                  <div className="alert alert-danger" role="alert">
                    Invalid user address
                  </div>
                </div>
              </div>
            </section>
          )
      }

      <Footer />
    </div>);
}
export default Gallery;